import { createReducer, on } from '@ngrx/store';
import { AgencyUserState } from './agency-user.state';
import {
  CreatedAgencyUserEvent,
  GottenAgencyUsersEvent,
  UpdatedAgencyUserEvent,
} from './agency-user.events';

export const agencyUserKey = 'agency-user';

const initialState: AgencyUserState = {
  entities: {},
  byQuery: {},
};

export const agencyUserReducer = createReducer(
  initialState,

  on(CreatedAgencyUserEvent, (state, { agencyUser }) => {
    return {
      ...state,
      entities: { ...state.entities, [agencyUser.id]: agencyUser },
    };
  }),
  on(UpdatedAgencyUserEvent, (state, { agencyUser }) => {
    return {
      ...state,
      entities: { ...state.entities, [agencyUser.id]: agencyUser },
    };
  }),
  on(GottenAgencyUsersEvent, (state, { agencyUsers }) => {
    return {
      ...state,
      entities: { ...state.entities, ...Object.fromEntries(agencyUsers.map((x) => [x.id, x])) },
    };
  }),
  on(CreatedAgencyUserEvent, (state, { agencyUser }) => {
    return {
      ...state,
      entities: { ...state.entities, [agencyUser.id]: agencyUser },
    };
  }),
);
